import { render, staticRenderFns } from "./purchaseRequestDetail.vue?vue&type=template&id=addeafe2&scoped=true&"
import script from "./purchaseRequestDetail.vue?vue&type=script&lang=js&"
export * from "./purchaseRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRequestDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./purchaseRequestDetail.vue?vue&type=style&index=1&id=addeafe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addeafe2",
  null
  
)

export default component.exports